module.exports = __webpack_public_path__ + "3a9ce2d5fa4497d69db2f1b9b97561d8.jpg";